/* MegaGrowMart accessibility fixes for Warehouse 7 (WCAG 2.2 AA). No styling beyond ARIA, no tracking.
   1. Carousel slides the theme marks aria-hidden still hold focusable links: they leave the tab order while hidden.
   2. Scrollable strips and carousels are focusable containers; they get a role and a unique name.
   3. Images whose alt repeats the link text next to them become decorative (the text carries the name).
   4. Sections the theme renders outside any landmark (announcement bar, footer icon strip) become named regions.
   5. Theme "headings" that are paragraphs (promo tiles, icon strip titles) become real h3 elements, same classes.
   Runs at script time and again on any DOM change (no debounce longer than one frame). */
(function () {
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]:not([tabindex="-1"])';
  var SKIP_ROLE = /^(A|BUTTON|INPUT|SELECT|TEXTAREA|SUMMARY)$/;

  function fixHidden() {
    var hidden = document.querySelectorAll('[aria-hidden="true"]');
    for (var i = 0; i < hidden.length; i++) {
      var els = Array.prototype.slice.call(hidden[i].querySelectorAll(FOCUSABLE));
      if (hidden[i].matches(FOCUSABLE)) { els.push(hidden[i]); }
      for (var j = 0; j < els.length; j++) {
        var el = els[j];
        if (!el.hasAttribute('data-a11y-tab')) { el.setAttribute('data-a11y-tab', el.getAttribute('tabindex') || ''); }
        if (el.getAttribute('tabindex') !== '-1') { el.setAttribute('tabindex', '-1'); }
      }
    }
    var parked = document.querySelectorAll('[data-a11y-tab]');
    for (var k = 0; k < parked.length; k++) {
      var p = parked[k];
      if (!p.closest('[aria-hidden="true"]') && p.getAttribute('aria-hidden') !== 'true') {
        var t = p.getAttribute('data-a11y-tab');
        if (t) { p.setAttribute('tabindex', t); } else { p.removeAttribute('tabindex'); }
        p.removeAttribute('data-a11y-tab');
      }
    }
  }

  function nameFor(el, fallback, n) {
    var section = el.closest('.shopify-section') || el.closest('section');
    var h = section ? section.querySelector('h1, h2, h3, .section__title, .heading') : null;
    var text = h ? h.textContent.replace(/\s+/g, ' ').trim() : '';
    return (text || fallback) + (n > 1 ? ' ' + n : '');
  }

  function fixContainers() {
    var seen = {};
    var els = document.querySelectorAll('.scroller__inner, .flickity-enabled, [tabindex]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var ti = parseInt(el.getAttribute('tabindex') || '-1', 10);
      if (el.classList.contains('scroller__inner') && !el.hasAttribute('tabindex')) { el.setAttribute('tabindex', '0'); ti = 0; }
      /* the icon-strip carousel is plain content; its links are reachable on their own, so the container itself
         leaves the tab order (an inert focus stop with no action confuses keyboard users) */
      if (el.classList.contains('text-with-icons') && el.classList.contains('flickity-enabled')) {
        if (el.getAttribute('tabindex') !== '-1') { el.setAttribute('tabindex', '-1'); }
        continue;
      }
      if (ti < 0 || SKIP_ROLE.test(el.tagName) || el.getAttribute('role')) { continue; }
      var fallback = el.classList.contains('flickity-enabled') ? 'Carousel' : 'Scrollable list';
      var base = nameFor(el, fallback, 1);
      seen[base] = (seen[base] || 0) + 1;
      el.setAttribute('aria-label', nameFor(el, fallback, seen[base]));
      if (el.classList.contains('flickity-enabled')) { el.setAttribute('aria-roledescription', 'carousel'); }
      el.setAttribute('role', 'region');
    }
  }

  function fixRedundantAlt() {
    var imgs = document.querySelectorAll('a img[alt], figure img[alt]');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var alt = (img.getAttribute('alt') || '').replace(/\s+/g, ' ').trim().toLowerCase();
      if (!alt) { continue; }
      var box = img.closest('a') || img.closest('figure');
      var text = box.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
      if (text && text.indexOf(alt) !== -1) { img.setAttribute('alt', ''); }
    }
  }

  function fixLandmarks() {
    var sections = document.querySelectorAll('.shopify-section');
    for (var i = 0; i < sections.length; i++) {
      var s = sections[i];
      if (s.closest('header, main, footer, nav, aside, [role="region"], [role="banner"], [role="contentinfo"]')) { continue; }
      if (s.querySelector('header, main, footer, nav, aside, [role="banner"], [role="contentinfo"], [role="navigation"]')) { continue; }
      if (s.getAttribute('role')) { continue; }
      var label = s.querySelector('.announcement-bar') ? 'Announcement' : s.querySelector('.text-with-icons') ? 'Store highlights' : '';
      if (!label) { continue; }
      s.setAttribute('role', 'region');
      s.setAttribute('aria-label', label);
    }
  }

  function fixHeadings() {
    /* the theme renders tile and strip titles as <p>; swap each for a real heading with the same classes and
       attributes, so it looks the same and screen readers can navigate by heading */
    var ps = document.querySelectorAll('p.promo-block__heading, p.text-with-icons__title, p.heading.h3, p.heading.h2');
    for (var i = 0; i < ps.length; i++) {
      var p = ps[i];
      if (!p.textContent.trim()) { continue; }
      var h = document.createElement(p.classList.contains('h2') ? 'h2' : 'h3');
      for (var a = 0; a < p.attributes.length; a++) {
        var at = p.attributes[a];
        if (at.name !== 'role' && at.name !== 'aria-level') { h.setAttribute(at.name, at.value); }
      }
      while (p.firstChild) { h.appendChild(p.firstChild); }
      p.parentNode.replaceChild(h, p);
    }
  }

  var running = false;
  function run() {
    if (running) { return; }
    running = true;
    try {
      fixHidden();
      fixContainers();
      fixRedundantAlt();
      fixLandmarks();
      fixHeadings();
    } finally { running = false; }
  }
  /* run synchronously inside the observer: headless scanners and background tabs never fire animation frames,
     so a deferred pass could be missed. Every fix only writes when a value actually changes, so it settles. */
  function onMutate(records) {
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.type === 'childList' || r.attributeName === 'aria-hidden' || r.attributeName === 'class' || r.attributeName === 'tabindex') { run(); return; }
    }
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', run); } else { run(); }
  window.addEventListener('load', run);
  setTimeout(run, 0); setTimeout(run, 500); setTimeout(run, 2000);
  if (window.MutationObserver && document.body) {
    new MutationObserver(onMutate).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-hidden', 'tabindex', 'class'] });
  }
})();
